module.exports = __webpack_public_path__ + "static/media/Resource_Menu.63e6835a.svg";